module.exports = __webpack_public_path__ + "img/logo-cer-03-2.a0706e13.png";